import { Component, Input, OnInit, NgZone } from '@angular/core';
import { ModalController, ActionSheetController } from '@ionic/angular';
import { MediaServiceService } from 'src/app/services/mediaService/media-service.service';
import { Subscription } from 'rxjs';
import { ToasterService } from 'src/app/services/toaster/toaster.service';

@Component({
  selector: 'app-preview-invoice-image',
  templateUrl: './preview-invoice-image.component.html',
  styleUrls: ['./preview-invoice-image.component.scss'],
})
export class PreviewInvoiceImageComponent implements OnInit {

  @Input() invoiceImg: any = [];
  private mediaSubscribtion: Subscription;
  constructor(
    private modalController: ModalController,
    private mediaService: MediaServiceService,
    public actionSheetController: ActionSheetController,
    private zone: NgZone,
    private toast: ToasterService
  ) { }

  ngOnInit() { }

  close(type: any = '') {
    
    if(type == 2){
      if(this.invoiceImg.length == 3) return this.toast.presentToast('Max image upload limit reached!')
    }

    this.modalController.dismiss({ type: type, img: this.invoiceImg });
  }

  /**
   * 
   * Open action sheet for profile section options.
   */
  async PicActionSheet() {
    const actionSheet = await this.actionSheetController.create({
      header: 'Contest Image',
      buttons: [{
        text: 'Gallery',
        // role: 'destructive',
        icon: 'images',
        handler: () => {
          //console.log('Gallery');
          this.openGallery();
        }
      }, {
        text: 'Camera',
        icon: 'camera',
        handler: () => {
          // console.log('camera');
          this.openCamera();
        }
      }, {
        text: 'Cancel',
        icon: 'close',
        role: 'cancel',
        handler: () => {
          //console.log('Cancel clicked');

        }
      }]
    });
    await actionSheet.present();

    const { role } = await actionSheet.onDidDismiss();
    // console.log('onDidDismiss resolved with role', role);
  }
  /**
   * Open Gallery images
   */
  async openGallery() {
    this.mediaService.galleryImage();
    this.mediaSubscribtion = this.mediaService.returnImage.subscribe(res => {
      console.log('gallery', res)
      if (res == 'cancelled') return this.callUnsubscribeFunction()
      this.invoiceImg.push(JSON.parse(JSON.stringify(res)));
      this.callUnsubscribeFunction();

    })
  }
  /**
   * Open camera 
   */
  async openCamera() {
    this.mediaService.captureImage();
    this.mediaSubscribtion = this.mediaService.returnImage.subscribe(res => {
      console.log('camera', res)
      if (res == 'cancelled') return this.callUnsubscribeFunction()
      this.invoiceImg.push(JSON.parse(JSON.stringify(res)));
      this.callUnsubscribeFunction();

    })
  }
  /**
 * Cancel the media subscription
 */
  callUnsubscribeFunction() {
    this.mediaSubscribtion.unsubscribe();
  }

}
